import { SimpleSelectElement } from 'components/molecules';
import { settlementTexts } from 'consts/text';
import { formFields } from 'consts/form/formFields';
import { CostAllocationRefersTo } from 'types';
import { useWatch } from 'antd/es/form/Form';
import { CoursePicker } from 'components/organisms/FormItems/CoursePicker';

const options = [
    { value: CostAllocationRefersTo.STAY, label: settlementTexts.children.costAllocation.stay },
    {
        value: CostAllocationRefersTo.MEAL,
        label: settlementTexts.children.costAllocation.meals,
    },
    {
        value: CostAllocationRefersTo.EXTRA_LESSONS,
        label: settlementTexts.children.costAllocation.extraLessons,
    },
];

export const CostAllocationTargetPicker = () => {
    const selectedRefersTo = useWatch(formFields.refersTo);

    return (
        <>
            <SimpleSelectElement
                name={formFields.refersTo}
                label={settlementTexts.children.costAllocation.costAllocationTarget}
                options={options}
            />
            {selectedRefersTo === CostAllocationRefersTo.EXTRA_LESSONS && <CoursePicker />}
        </>
    );
};
